import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';

const InsuredIsKentuckyField = ({ name, validate }) => (
  <div className="form-group">
    <div className="mb-1">
      Is the insured the State of Kentucky, one of its agencies or political
      subdivisions?
    </div>

    <div className="custom-control custom-radio">
      <Field
        name={name}
        value="yes"
        id={`${name}Yes`}
        validate={validate}
        component="input"
        type="radio"
        className="custom-control-input"
      />
      <label className="custom-control-label label" htmlFor={`${name}Yes`}>
        Yes
      </label>
    </div>

    <div className="custom-control custom-radio">
      <Field
        name={name}
        value="no"
        id={`${name}No`}
        validate={validate}
        component="input"
        type="radio"
        className="custom-control-input"
      />
      <label className="custom-control-label label" htmlFor={`${name}No`}>
        No
      </label>
    </div>
  </div>
);
InsuredIsKentuckyField.propTypes = {
  name: PropTypes.string.isRequired,
  validate: PropTypes.arrayOf(PropTypes.func).isRequired,
};

export default InsuredIsKentuckyField;
